export default "__VITE_ASSET__CvbGFdsw__"